import React from "react";
import { useLocation } from "react-router-dom";
import { Menu, Bell, Search, Globe, AlignLeft, MessageSquare } from "react-feather";
import { Link } from "react-router-dom";
import OffcanvasSidebar from "./OffcanvasSidebar";
import TimeComponent from "./TimeComponent";

const AdminTopbar = () => {
  const location = useLocation(); // Get the current location

  // Get breadcrumb labels dynamically (modify as needed)
  const getBreadcrumbLabel = (path) => {
    switch (path) {
      case "/admin/dashboard":
        return "Project Lifecycle Management";
      case "/admin/category":
        return "Category Management";
      default:
        return "Dashboard";
    }
  };

  // Current page label
  const currentLabel = getBreadcrumbLabel(location.pathname);

  return (
    <div className="bg-white sticky-top  py-2  lkl px-4">
      <div className="px-4 d-flex align-items-center justify-content-between">
        {/* Left: Hamburger Icon & Page Title */}
        <div className="d-flex align-items-center">
          <AlignLeft
            size={25}
            className="me-3 text-primary cursor-pointer"
            data-bs-toggle="offcanvas"
            href="#offcanvasExample"
            role="button"
            aria-controls="offcanvasExample"
          />

          <OffcanvasSidebar />

          {/* <h5 className="mb-0 text-warning fw-bold text-decoration-underline">
            {currentLabel}
          </h5> */}
          <div>
            <TimeComponent/>
          </div>
        </div>

        {/* Right: Search, Notifications, and Language Selector */}
        <div className="d-flex align-items-center">
          <div className="position-relative me-3 lp1 py-1">
            <Search size={18} className="text-secondary mx-2" />
            <input
              type="text"
              placeholder="Search here..."
              className="border-0 ps-1"
              style={{
                outline: "none",
                background: "transparent",
                width: "300px",
              }}
            />
          </div>

          {/* Notification Bell with Indicator */}
          <div className="position-relative me-3">
            <Bell size={18} className="text-secondary" />
            <span
              className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"
              style={{ fontSize: "8px" }}
            ></span>
          </div>

          {/* Language Selector */}
          <Globe size={18} className="text-secondary me-3" />


          <Link to={`/chat-window`}>
          <MessageSquare size={18} className="text-secondary" />
          </Link>
          
        </div>
      </div>
    </div>
  );
};

export default AdminTopbar;
